/**
 * @typedef {import('react')} React
 */
import { createContext, useContext, useState } from 'react';

const StoreContext = createContext();

/**
 * StoreProvider sets up the global store context.
 * @param {object} props - Props passed to the provider component.
 * @param {React.ReactNode} props.children - Child components wrapped by the provider.
 * @returns {import('react').ReactElement} A React element that provides context to its children.
 */
export const StoreProvider = ({ children }) => {
  const initialState = {
    authToken: '',
    db_ptr: '',
    order_id: '',
    amount: 0,
    country: 'IND',
    paymentSuccess: false,
    paymentID: '',
  };
  // const initialState = {
  //   country: 'IND',
  //   db_ptr: 'nuraclt',
  //   show: {
  //     couponModule: false,
  //   },
  //   branchptr: '7',
  //   firmptr: '7',
  //   cart_total: 35000,
  //   order_id: '',
  //   coupon_code: '',
  //   session_id: '',
  //   guests: [
  //     {
  //       firstName: 'Sharanya',
  //       lastName: 'Rao',
  //       age: '30',
  //       gender: 'Female',
  //       phone: '9999999998',
  //       email: 'sharanya@gmail.com',
  //       screeningPackages: 'Nura Women’s Health Screening',
  //       package_value: '17',
  //       doctor: '22',
  //       price: 18000,
  //       slotDate: '2025-08-16',
  //       slotTime: '01:00 PM',
  //       tokenNumber: 20,
  //       phoneVerified: true,
  //       displayDate: 'Fri, 15 Aug 2025',
  //     },
  //     {
  //       firstName: 'Shreyas',
  //       lastName: 'Rao',
  //       age: '35',
  //       gender: 'Male',
  //       phone: '9999999999',
  //       email: 'shreyas@gmail.com',
  //       screeningPackages: 'Nura Men’s Health Screening',
  //       package_value: '16',
  //       doctor: '22',
  //       price: 20000,
  //       slotDate: '2025-08-16',
  //       slotTime: '01:30 PM',
  //       tokenNumber: 22,
  //       phoneVerified: true,
  //       displayDate: 'Fri, 15 Aug 2025',
  //     },
  //   ],
  //   ptr_info: {
  //     Bengaluru: {
  //       db_ptr: 'nura',
  //       branch_ptr: '1',
  //       firm_ptr: '1',
  //       alt_name: 'Bangalore',
  //     },
  //     Gurugram: {
  //       db_ptr: 'nuradel',
  //       branch_ptr: '2',
  //       firm_ptr: '2',
  //       alt_name: 'Gurgaon',
  //     },
  //     Mumbai: {
  //       db_ptr: 'nuramum',
  //       branch_ptr: '3',
  //       firm_ptr: '3',
  //       alt_name: 'Bombay',
  //     },
  //     Hyderabad: {
  //       db_ptr: 'nurahyd',
  //       branch_ptr: '4',
  //       firm_ptr: '4',
  //       alt_name: 'Hyderabad',
  //     },
  //     Calicut: {
  //       db_ptr: 'nuraclt',
  //       branch_ptr: '7',
  //       firm_ptr: '7',
  //       alt_name: 'Kozhikode',
  //     },
  //     CTBus: {
  //       branch_ptr: '8',
  //       firm_ptr: '8',
  //       alt_name: 'CTBus',
  //     },
  //   },
  //   authToken:
  //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VyTmFtZSI6IndlYnNpdGVAbnVyYS5pbiIsIklEIjo4OCwiTW9kZSI6InN0YWZmIiwiaWF0IjoxNzU1MDY3MTc4LCJleHAiOjE3NTc2NTkxNzh9.XJEw6unKS4FvI64cE1X3PZCJtnk9cOEczwC5kx6Yrzo',
  // };

  const [paymentData, setPaymentData] = useState(initialState);

  return (
    <StoreContext.Provider value={{ paymentData, setPaymentData }}>
      {children}
    </StoreContext.Provider>
  );
};

/**
 * Custom hook to access the global store.
 * @returns {{ paymentData: object, setPaymentData: Function }} The store state and its setter.
 */
export const useStore = () => useContext(StoreContext);
